import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";
import React from "react";
import { Trans } from "react-i18next";
const useStyles = makeStyles((theme) => ({
    instructionsContainer: {
        backgroundColor: theme.palette.secondary.light,
        padding: theme.spacing(1),
        textAlign: "center",
        color: "black",
        "& h3": {
            marginTop: 0,
            fontSize: "20px",
            fontWeight: 400,
        },
        "& p": {
            fontSize: "15px",
            margin: theme.spacing(1),
        },
    },
}));
const YearbookPoseInstructions = ({ pictureSet, jobYearbookPose, }) => {
    const classes = useStyles();
    const instructions = jobYearbookPose.instructions;
    let instructionsComponents = [];
    if (instructions) {
        instructionsComponents = instructions.split("\n").map((line, index) => {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { key: index }, line),
                React.createElement("br", null)));
        });
    }
    return (React.createElement(Box, { className: classes.instructionsContainer },
        React.createElement("h3", null,
            React.createElement(Trans, null, "Selection instructions")),
        React.createElement("p", null, instructionsComponents)));
};
export default YearbookPoseInstructions;
